import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  font: normal normal normal 14px/17px Inter;
  letter-spacing: 0px;
  color: ${props => props.theme.colors.color6b7786};
`

export const Content = styled.div`
  word-break: break-word;
  b {
    font-weight: bold;
  }
`
